import SimpleServiceBooking from '@/modules/simpleService/views/SimpleServiceBooking';
import SimpleServiceBookingConfirm from '@/modules/simpleService/views/SimpleServiceBookingConfirm';

export default [
  {
    path: '/',
    component: SimpleServiceBooking
  },
  {
    name: 'bookingConfirmed',
    path: '/booking/confirm',
    component: SimpleServiceBookingConfirm
  }
];
